"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.darkPalette = void 0;
var _primitives = require("./primitives");
/**
 * Dark palette — the primary product experience.
 *
 * Values are EXACTLY the historical `PitBrain.Mobile/constants/Colors.tsx`
 * DarkThemeColors so centralizing tokens causes zero visual change in dark
 * mode. Only additive keys (e.g. `accentSolid`) are new.
 */
const darkPalette = exports.darkPalette = {
  appBackground: _primitives.brand.navy,
  background: _primitives.brand.navy,
  card: 'rgba(20, 35, 55, 0.92)',
  navigationBar: '#F4F4F4',
  cardStrong: 'rgba(94, 94, 105, 0.95)',
  section: 'rgba(255, 255, 255, 0.05)',
  modalBackground: '#1A2332',
  modalCard: '#2A3441',
  // Historical translucent cyan (brand.cyan at ~52% alpha). Kept verbatim so
  // existing dark surfaces don't shift; new code should use accentSolid.
  accent: '#4fc2f785',
  accentSolid: _primitives.brand.cyan,
  accentSecondary: '#2196F3',
  text: '#FFFFFF',
  textSecondary: '#B0B0B0',
  textTertiary: '#B0B0B0',
  // Lighter than textSecondary so secondary text clears WCAG AA on the
  // (pixel-locked) cardStrong surface, where #B0B0B0 is only 3.14:1.
  textSecondaryOnStrong: '#D8D8D8',
  textOnAccent: '#FFFFFF',
  tabBarActiveTintColor: _primitives.brand.blue,
  tabBarInactiveTintColor: '#6B7280',
  error: _primitives.statusHues.redSoft,
  success: _primitives.statusHues.greenSoft,
  warning: _primitives.statusHues.amberSoft,
  disabled: '#767577',
  border: 'rgba(255, 255, 255, 0.15)',
  shadow: 'rgba(0, 0, 0, 0.3)',
  primary: _primitives.brand.blue,
  primaryLight: 'rgba(37, 99, 235, 0.15)',
  sessionGradientStart: _primitives.gradientStops.session.start,
  sessionGradientEnd: _primitives.gradientStops.session.end,
  lapGradientStart: _primitives.gradientStops.lap.start,
  lapGradientEnd: _primitives.gradientStops.lap.end,
  sharedLapsGradientStart: _primitives.gradientStops.sharedLaps.start,
  statIconPrimary: _primitives.brand.blue,
  statIconBlue: '#3B82F6',
  statIconGreen: '#22C55E',
  badgeBackground: 'rgba(255, 255, 255, 0.12)',
  badgeText: '#B0B0B0'
};